import * as React from "react";
import { useLazyQuery as useLazyQuery$1 } from "@apollo/client";
import { handleError } from "./helpers.js";
const useLazyQuery = (query, options) => {
  const [executable, result] = useLazyQuery$1(query, options);
  const { error } = result;
  React.useEffect(() => {
    if (error) {
      handleError(query, error);
    }
  }, [error, query]);
  return [executable, result];
};
export {
  useLazyQuery as default
};
//# sourceMappingURL=use-lazy-query.js.map
